import { render, staticRenderFns } from "./CustomerLogs.vue?vue&type=template&id=c51b1178"
import script from "./CustomerLogs.vue?vue&type=script&lang=js"
export * from "./CustomerLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports